<template>
  <div>
    <div
      v-if="mode == 'preview'"
      :class="['place-preview', editMode ? 'clickable' : null]"
      @click="editMode ? (mode = 'edit') : null"
    >
      <img :src="$anm22.icons.getWorldIcon('placeBlack')" class="label-ic" />
      <div v-if="isPlaceSet">
        <div v-if="place.name" class="place-name">{{ place.name }}</div>
        {{ addressToString }}
      </div>
      <div v-else>
        {{ $anm22.strLang(lang, "Add location", "Aggiungi luogo") }}
      </div>
    </div>
    <div v-if="mode == 'edit'" class="place-edit">
      <div class="place-edit-title">
        <img :src="$anm22.icons.getWorldIcon('placeBlack')" class="label-ic" />
        <div>
          {{ $anm22.strLang(lang, "Add location", "Aggiungi luogo") }}
        </div>
      </div>
      <div
        class="display-flex com-anm22-app-scrolling-panel"
        style="flex-wrap: nowrap; overflow-x: auto; width: 100%"
        v-if="values.length != 0"
      >
        <div v-for="(value, index) in values" :key="'place-find' + index">
          <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
          <div
            class="com-anm22-app-text-m list-element-label place-hint"
            @click="addPlace(value.id)"
          >
            {{ value.label }}
          </div>
        </div>
      </div>
      <iframe
        v-if="place.city"
        width="100%"
        height="450"
        frameborder="0"
        style="border: 0"
        :src="
          'https://www.google.com/maps/embed/v1/place?key=' +
          mapsAPIKey +
          '&q=' +
          googleQuery
        "
        allowfullscreen
      ></iframe>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "Location name", "Nome luogo") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-8">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            @keyup="getValues"
            type="text"
            v-model="place.name"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "Address", "Indirizzo") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="place.street"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
          />
        </div>
        <div class="wg-col wg-xs-12 wg-sm-2">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="place.number"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'Number', 'N. civico')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "City", "Città") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-8">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="place.city"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "ZIP code", "CAP") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-8">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="place.zip"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "State", "Provincia") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-8">
          <input
            :disabled="!editMode"
            class="anm22-calendar-input-text"
            style="max-width: 100%"
            type="text"
            v-model="place.state"
            @input="updateValue"
            :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
          {{ $anm22.strLang(lang, "Country", "Paese") }}
        </div>
        <div class="wg-col wg-xs-12 wg-sm-8">
          <select
            :disabled="!editMode"
            class="input-elem com-anm22-app-select"
            v-model="place.country"
            @input="updateValue"
          >
            <option
              v-for="obj in Object.values(
                $anm22.tableClasses.worldCountry().getAll()
              ).sort((a, b) =>
                a[lang] < b[lang] ? -1 : b[lang] > b[lang] ? 1 : 0
              )"
              :key="'country-' + obj.typeClassLiteral"
              :value="obj.typeClassLiteral"
            >
              {{ obj[lang] }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    editMode: [Boolean],
  },
  data() {
    return {
      mode: "preview",
      place: { ...this.value },
      values: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      mapsAPIKey: (state) => state.config.mapsAPIKey,
      lang: (state) => state.lang,
    }),
    googleQuery() {
      let query;
      if (this.place.name != undefined) {
        query = this.place.name + ",+";
      } else {
        query = "";
      }
      if (this.place.street != undefined) {
        query += this.place.street + "+";
      } else {
        query += "";
      }
      if (this.place.number != undefined) {
        query += this.place.number + ",+";
      } else {
        query += "";
      }
      if (this.place.city != undefined) {
        query += this.place.city + ",+";
      } else {
        query += "";
      }
      if (this.place.zip != undefined) {
        query += this.place.zip + ",+";
      } else {
        query += "";
      }
      if (this.place.state != undefined) {
        query += this.place.state + ",+";
      } else {
        query += "";
      }
      if (this.place.country != undefined) {
        query += this.place.country;
      } else {
        query += "";
      }
      return query.replace("&", "e");
    },
    placeToString() {
      let string = "";
      if (this.place.name != undefined) {
        string = this.place.name;
      } else {
        string = "";
      }
      const addressString = this.addressToString;
      if (string && addressString) {
        string += ", ";
      }
      return string + addressString;
    },
    addressToString() {
      let string = "";
      if (this.place.street != undefined) {
        string += this.place.street + " ";
      } else {
        string += "";
      }
      if (this.place.number != undefined) {
        string += this.place.number + ", ";
      } else {
        string += "";
      }
      if (this.place.zip != undefined) {
        string += this.place.zip;
      } else {
        string += "";
      }
      if (this.place.city != undefined) {
        if (this.place.zip) {
          string += " ";
        }
        string += this.place.city + " ";
      } else {
        string += "";
      }
      if (this.place.state != undefined) {
        if (this.place.zip || this.place.city) {
          string += " ";
        }
        string += this.place.state;
      } else {
        string += "";
      }
      if (this.place.zip || this.place.city || this.place.state) {
        string += ", ";
      }
      if (this.place.country != undefined) {
        string += this.place.country.toUpperCase();
      } else {
        string += "";
      }
      return string;
    },
    isPlaceSet() {
      if (!this.place) {
        return false;
      }
      if (
        this.place.name ||
        this.place.street ||
        this.place.number ||
        this.place.city ||
        this.place.zip ||
        this.place.state
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    addPlace(idPlace) {
      this.values = [];
      this.$http
        .post(
          "events/getplacedata",
          {
            idPlace,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.event.contactPlace = response.data.place.idContactsPlace;
          this.event.placeName = response.data.place.name;
          this.event.placeStreet = response.data.place.addressStreet;
          this.event.placeNumber = response.data.place.addressNumber;
          this.event.placeCity = response.data.place.addressCity;
          this.event.placeZip = response.data.place.addressZip;
          this.event.placeState = response.data.place.addressState;
          this.event.placeCountry = response.data.place.addressCountry;
          this.manual = true;
        })
        .catch((error) => {});
    },
    getValues() {
      return _.debounce(function () {
        let val = this.event.placeName;
        if (val.length > 1) {
          this.values = [];
          this.$http
            .post(
              "events/getplaces",
              {
                string: this.event.placeName,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              if (response.data.length > 0) {
                const filtered = this.filters.reduce((result, fn) => {
                  return result.filter(fn);
                }, response.data);
                if (filtered.length > 0) {
                  this.values = filtered;
                } else {
                  this.noResults = true;
                }
              } else {
                this.noResults = true;
              }
            })
            .catch((error) => console.log(error));
        } else {
          this.values = [];
          this.noResults = false;
        }
      }, 1000).bind(this);
    },
    updateValue() {
      this.$emit("input", this.place);
    },
  },
  watch: {
    value(newValue) {
      this.place = { ...newValue };
    },
  },
};
</script>

<style lang="scss" scoped>
.place-preview {
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 6px 0 6px 0;

  &.clickable {
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }

  .place-name {
    font-weight: 500;
  }

  .label-ic {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
.place-edit {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 6px 0 12px 0;

  .place-edit-title {
    display: flex;
    align-items: center;
    border-radius: 6px;
    padding: 6px 0 12px 0;
    font-weight: 500;

    .label-ic {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
}
</style>
